const KEYS = {
    TOKEN: 'tokenBardy',
    REFRESH_TOKEN: 'refreshTokenBardy',
    ORG: 'organizationBardy',
    ORG_ID: 'organizationIdBardy',
    USER: 'userBardy',
    ROLES: 'rolesBardy',
}

export const AUTH_ROUTES = ['/sessions', '/accounts', '/password-reset-tokens']

export const getToken = (): string | undefined => localStorage.getItem(KEYS.TOKEN) || undefined
export const getRefreshToken = (): string | undefined => localStorage.getItem(KEYS.REFRESH_TOKEN) || undefined

export const setAuthCookies = (token?: string, refreshToken?: string) => {
    if (token) localStorage.setItem(KEYS.TOKEN, token)
    if (refreshToken) localStorage.setItem(KEYS.REFRESH_TOKEN, refreshToken)
}

export const removeAuthCookies = () => {
    localStorage.removeItem(KEYS.TOKEN)
    localStorage.removeItem(KEYS.REFRESH_TOKEN)
}

export const getOrganizationId = (): string | undefined => {
    const localOrgId = localStorage.getItem(KEYS.ORG_ID)
    if (localOrgId) return localOrgId

    const localOrg = localStorage.getItem(KEYS.ORG)
    if (localOrg) {
        try {
            const org = JSON.parse(localOrg)
            if (org?.id) return org.id
        } catch {
            /* ignore */
        }
    }

    return process.env.VUE_APP_ORGANIZATION_ID
}

export const getOrganization = () => {
    const localOrg = localStorage.getItem(KEYS.ORG)
    return localOrg ? JSON.parse(localOrg) : null
}

export const setOrganization = (organization: any) => {
    const orgString = JSON.stringify(organization)
    localStorage.setItem(KEYS.ORG, orgString)

    if (organization?.id) {
        localStorage.setItem(KEYS.ORG_ID, organization.id)
    }
}

export const setUser = (user: any) => {
    localStorage.setItem(KEYS.USER, JSON.stringify(user))
}

export const getUser = () => {
    const localUser = localStorage.getItem(KEYS.USER)
    return localUser ? JSON.parse(localUser) : null
}

export const removeStorageItems = () => {
    localStorage.removeItem(KEYS.ORG)
    localStorage.removeItem(KEYS.ORG_ID)
    localStorage.removeItem(KEYS.USER)
    localStorage.removeItem(KEYS.ROLES)
    localStorage.removeItem(KEYS.TOKEN)
    localStorage.removeItem(KEYS.REFRESH_TOKEN)
}

export const isAuthRoute = (url?: string) => AUTH_ROUTES.some((route) => url?.includes(route))

export function parseJwt(token: string) {
    try {
        const parts = token.split('.')
        if (parts.length < 2) return null

        const base64Url = parts[1]
        if (!base64Url) return null

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join(''),
        )

        return JSON.parse(jsonPayload)
    } catch {
        return null
    }
}
